import { mapGetters } from 'vuex';
export default {
    name: 'homeLinks',
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('home', ['home']),
    },
};
